export default "__VITE_ASSET__CogkNNYP__"